<script lang="ts">
	import { getInquiryPath } from "@core/schema/paths/getInquiryPath.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import type { HomepageCategory } from "../templates/HomepageProps.js";
	import { getTranslate } from "../utils/getTranslate.js";
	import ServiceCardsGrid from "./ServiceCardsGrid.svelte";
	import translation from "./Services.translations.json" with { type: "json" };
	import Formatted from "./common/Formatted.svelte";
	import Link from "./common/Link.svelte";
	import TextWithIcon from "./common/TextWithIcon.svelte";
	import { ButtonVariant } from "./common/getButtonClass.js";

	const { categories }: { categories: HomepageCategory[] } = $props();
	const translate = getTranslate(translation);
	const { tenant } = getGlobalTemplateProps();
</script>

<section class="container-center flex flex-col gap-8 sm:gap-12 md:gap-16 lg:gap-24">
	<div class="grid gap-6 md:gap-8 lg:gap-12 lg:grid-cols-2">
		<h2 class="text-left hidden sm:inline-block text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl">
			<Formatted text={translate("heading")} />
		</h2>
		<h2 class="sm:hidden text-left text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl">
			<Formatted text={translate("headingSmall")} />
		</h2>
		<div class="flex flex-col gap-4 sm:gap-6 md:gap-8 lg:gap-16 h-full">
			<p
				class="font-normal text-left md:text-left text-sm sm:text-base md:text-lg/[1.4] text-optical-black flex flex-col gap-4 sm:gap-6 h-full"
			>
				<span><Formatted text={translate("text1")} /></span>
				<span>
					<Formatted text={translate("text2")} />
				</span>
			</p>
			<div>
				<Link href={getInquiryPath(tenant)} variant={ButtonVariant.OutlinedWithIcon}>
					<TextWithIcon><Formatted text={translate("contactUs")} /></TextWithIcon>
				</Link>
			</div>
		</div>
	</div>
	<ServiceCardsGrid {categories} />
</section>
